import React, { useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { VectorBackground } from "../components/VectorBackground";

const FaqAccordion = ({ header, items, id = "faq" }) => {
    const [activeIndex, setActiveIndex] = useState(null);
    const validItems = items?.filter(
        (item) => item?.question?.trim() && item?.answer?.trim()
    );

    const toggle = (index) => {
        setActiveIndex(activeIndex === index ? null : index);
    };

    if (!validItems?.length) return null;

    return (
        <section className="faq-accordion" id={id}>
            <Container>
                <div className="faq-accordion__container">
                    <VectorBackground gradient />
                    <div className="faq-accordion__content">
                        {header && (
                            <Row className="faq-accordion__header-row">
                                <Col>
                                    <h2
                                        className="faq-accordion__header"
                                        dangerouslySetInnerHTML={{
                                            __html: header,
                                        }}
                                    />
                                </Col>
                            </Row>
                        )}
                        <Row className="faq-accordion__items-row">
                            <Col lg={16} xs={24}>
                                <div className="faq-accordion__list">
                                    {validItems.map((item, index) => (
                                        <div
                                            key={index}
                                            className={`faq-accordion__item ${
                                                activeIndex === index
                                                    ? "faq-accordion__item--active"
                                                    : ""
                                            }`}
                                        >
                                            <button
                                                className="faq-accordion__question"
                                                onClick={() => toggle(index)}
                                                aria-expanded={
                                                    activeIndex === index
                                                }
                                            >
                                                <span
                                                    className="faq-accordion__question-text"
                                                    dangerouslySetInnerHTML={{
                                                        __html: item.question,
                                                    }}
                                                />
                                                <span
                                                    className="faq-accordion__icon"
                                                    aria-hidden="true"
                                                >
                                                    <svg
                                                        width="13"
                                                        height="13"
                                                        viewBox="0 0 13 13"
                                                        fill="none"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                    >
                                                        <rect
                                                            y="7.5"
                                                            width="2"
                                                            height="13"
                                                            rx="1"
                                                            transform="rotate(-90 0 7.5)"
                                                            fill="#22272D"
                                                        />
                                                        {activeIndex !==
                                                            index && (
                                                            <rect
                                                                x="5.5"
                                                                width="2"
                                                                height="13"
                                                                rx="1"
                                                                fill="#22272D"
                                                            />
                                                        )}
                                                    </svg>
                                                </span>
                                            </button>
                                            {activeIndex === index &&
                                                item.answer && (
                                                    <div
                                                        className="faq-accordion__answer"
                                                        dangerouslySetInnerHTML={{
                                                            __html: item.answer,
                                                        }}
                                                    />
                                                )}
                                        </div>
                                    ))}
                                </div>
                            </Col>
                        </Row>
                    </div>
                </div>
            </Container>
        </section>
    );
};

export default FaqAccordion;
